import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { DiscoveryHttpService } from '@/infrastructure/utils/discovery-http-service';
import type { CompanyApi } from '../company-api';
import type { CompanyInfo, GenerateSearchQueryIdResponse, GenerateSearchQueryIdRequest } from '../../types';

@injectable()
export class CompanyApiImpl extends DiscoveryHttpService implements CompanyApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_DISCOVERY_SERVICE_URI}/discovery-api/2.0`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    getInfo(id: string, type: string) {
        return this.get<CompanyInfo>({
            url: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/discovery-api/2.0/organization/${id}/info`,
            params: {
                type,
            },
        });
    }

    generateSearchQueryId(data: GenerateSearchQueryIdRequest) {
        return this.post<GenerateSearchQueryIdResponse>({
            url: '/search/history',
            data,
        });
    }
}
